<template lang="pug">
	b-card
		blockquote.card-blockquote
			h5 {{ _lecture.title }}
			p {{ _lecture.description }}
			footer
				small.mb-3(v-if="_lecture.attachment")
					| Доклад:
					|
					a(:href="_lecture.attachment" target="_blank") скачать

		footer.g-between-center
			.text-info(v-if="!_lecture.approved") На модерации
			.text-success(v-else) Подтвержден
			b-button(variant='primary' size='sm' v-if="!_lecture.approved" @click="openModalEdit") Редактировать

		lectureModalEdit(:_lecture="_lecture")

</template>

<script>
	import lectureModalEdit from '../../../components/modals/lectureModalEdit'


	export default {
		name: 'lectureCard',
		props:['_lecture'],
		components: {
			lectureModalEdit,
		},
		data: () => ({}),
		methods: {
			openModalEdit() { this.$bvModal.show(`lectureModalEdit-${this._lecture.id}`) },
		},
	}
</script>
